import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  if (movies.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {movies.map((m) => (
        <Link
          key={m.id}
          to={`/detail/${m.id}`}
          className="group flex gap-3 overflow-hidden rounded-lg border border-background-200/70 bg-background-100 p-3 transition-all duration-300 hover:border-primary-300 cursor-pointer"
        >
          <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img src={m.poster} alt={`${m.title} 海报`} title={m.title} className="h-full w-full object-top" />
          </div>
          <div className="flex min-w-0 flex-col">
            <h4 className="font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 line-clamp-1">
              {m.title}
            </h4>
            <p className="mt-1 text-xs text-foreground-500">{m.year} · {m.region}</p>
            <p className="mt-1 text-xs text-foreground-600 line-clamp-2">{m.genres.join(' · ')}</p>
            <span className="mt-auto flex items-center gap-1 text-[11px] text-accent-600">
              <i className="ri-star-fill text-[10px]"></i>{m.rating.toFixed(1)}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}